import { 
  HOME_ACTION, 
  COMMON_CONTENT_ACTION, 
  HOME_ACTION_LOADER,
  COMMON_CONTENT_ACTION_LOADER,
  COMMON_CONTENT_ACTION_ERROR,
  COMMON_CART_ACTION,
  COMMON_CART_QTY_ACTION
} from "../type"
 
const initialState ={
    loader : false,
    common_loader: false, // 👈 add this
    common_loaded: false,
    common_error: null,
    data :{},
    common_data :{}
}
 
// Format amount the way PrestaShop formatted sample ("€1,234.00", "€ 1.234,00"): same symbol, separators and decimals.
// A sample without a number (e.g. "Free") is returned as it is.
const formatPriceLike = (sample, amount) => {
    if (typeof sample !== 'string') return sample;
    const match = sample.match(/\d[\d.,\s  ]*\d|\d/);
    if (!match) return sample;
    const number = match[0];
    const hasDecimals = /[.,]\d{2}$/.test(number);
    const decimalSep = hasDecimals ? number[number.length - 3] : '';
    const thousandsMatch = (hasDecimals ? number.slice(0, -3) : number).match(/\D/);
    const thousandsSep = thousandsMatch ? thousandsMatch[0] : (decimalSep === ',' ? '.' : ',');
    const [int, frac] = Math.abs(amount).toFixed(hasDecimals ? 2 : 0).split('.');
    const formatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep) + (frac ? decimalSep + frac : '');
    return sample.slice(0, match.index) + (amount < 0 ? '-' : '') + formatted + sample.slice(match.index + number.length);
};

const HomeReducer  = (state = initialState, action) => {
    switch (action.type){

        case HOME_ACTION_LOADER:
            return {...state, loader : action.loader};

        case COMMON_CONTENT_ACTION_LOADER:  // 👈 add this
            return {...state, common_loader : action.loader};

        case HOME_ACTION:
            return {...state, data: action.data};

        case COMMON_CONTENT_ACTION:
            return {...state, common_data: action.data, common_loaded: true, common_error: null};

        // The cart API returns the same presented cart as common content: use it directly.
        case COMMON_CART_ACTION:
            if (!action.cart) return state;
            return {...state, common_data: {...state.common_data, cart: action.cart}};

        case COMMON_CART_QTY_ACTION: {
            // Optimistic: new quantity, line total, subtotal and total at once (unit price x quantity).
            // Shipping, discounts and tax stay as they are until the cart_update response replaces the cart.
            const cart = state.common_data?.cart;
            if (!cart?.products) return state;
            let delta = 0;
            const products = cart.products.map((p) => {
                if (
                    String(p.id_product) !== String(action.id_product) ||
                    String(p.id_product_attribute ?? 0) !== String(action.id_product_attribute ?? 0) ||
                    String(p.id_customization ?? 0) !== String(action.id_customization ?? 0)
                ) {
                    return p;
                }
                const unit = Number(p.price_amount ?? p.price_wt);
                if (!Number.isFinite(unit)) {
                    return {...p, cart_quantity: action.quantity, quantity: action.quantity};
                }
                const lineTotal = unit * action.quantity;
                delta = lineTotal - unit * Number(p.cart_quantity);
                return {
                    ...p,
                    cart_quantity: action.quantity,
                    quantity: action.quantity,
                    total: formatPriceLike(p.total, lineTotal),
                    total_wt: lineTotal,
                };
            });
            const addDelta = (line) => line && typeof line.amount === 'number'
                ? {...line, amount: line.amount + delta, value: formatPriceLike(line.value, line.amount + delta)}
                : line;
            const subtotals = cart.subtotals && {...cart.subtotals, products: addDelta(cart.subtotals.products)};
            const totals = cart.totals && {
                ...cart.totals,
                total: addDelta(cart.totals.total),
                total_including_tax: addDelta(cart.totals.total_including_tax),
            };
            return {...state, common_data: {...state.common_data, cart: {...cart, products, subtotals, totals}}};
        }

        // Keep the last good common_data; just stop waiting for it.
        case COMMON_CONTENT_ACTION_ERROR:
            return {...state, common_loaded: true, common_error: action.error || true};

        default:
            return state
    }
}
 
export default HomeReducer;
